import { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { usePosts } from "../hooks/queries/usePosts";

const useViewPostsFacade = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const companyParam = new URLSearchParams(search).get("company");


  const { user } = useSelector((state) => state.user);
  const myCollegeName = (user?.collegeName || "").trim();

  const [postScope, setPostScope] = useState("global"); // "global" | "campus"

  const { data: posts, isLoading: loading } = usePosts({
    collegeName: myCollegeName,
    scope: postScope
  });


  const [searchTerm, setSearchTerm] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [activeFilters, setActiveFilters] = useState(null);



  useEffect(() => {
    if (companyParam) setSearchTerm(companyParam);
  }, [companyParam]);

  const filteredPosts = useMemo(() => {
    if (!posts) return [];

    let result = posts;


    // Existing dropdown filters
    if (activeFilters) {
      result = result.filter(
        (post) =>
          (post.company === activeFilters.company || activeFilters.company === "") &&
          (post.status === activeFilters.status || activeFilters.status === "") &&
          (post.role === activeFilters.role || activeFilters.role === "") &&
          (post.type === activeFilters.type || activeFilters.type === "")
      );
    }

    // Existing search
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      result = result.filter((post) => {
        const target = `${post.company} ${post.status} ${post.role} ${post.type}`.toLowerCase();
        return target.includes(lowerSearch);
      });
    }

    return result;
  }, [posts, searchTerm, activeFilters]);


  const handleFilter = (filters) => setActiveFilters(filters);

  return {
    loading,
    filteredPosts,
    searchTerm,
    setSearchTerm,
    showFilters,
    setShowFilters,
    handleFilter,
    navigate,


    postScope,
    setPostScope,
    myCollegeName,
  };
};

export default useViewPostsFacade;
